import React, { useEffect, useState, useMemo, useRef } from 'react'
import { Link, useLocation, useHistory } from 'react-router-dom'
import Api from '../../../_helpers/Api'
import { fromInfo, trans } from '../../../_providers/Translation'
import { useSocketContext } from '../../../_providers/Socket'
import { useAuthDataContext } from '../../../_providers/Auth'

//partials
import Table from './partials/Table'
import Pagination from '../../Pagination'
import Help from '../../partials/Help'
import SelectReservationType from './partials/modals/SelectReservationType'

import Reservation from './partials/Reservation'
import { Menu, MenuItem, Tab, Tabs } from '@mui/material'
import moment from 'moment'

let timeout

function Index() {

    const history = useHistory()
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search)

    const selectReservationTypeModalRef = useRef(null)
    const addAddressReservationButtonRef = useRef(null)

    const [reservations, setReservations] = useState({
        data: [],
        total: 0,
        pages: 0,
        page: 1,
        filter: {

        },
        loading: true,
        setFilter: false,
        update: false,
    })
    const [openButtonDropdown, setOpenButtonDropdown] = useState(null)

    const listener = useSocketContext()
    const auth = useAuthDataContext()

    useEffect(() => {
        const partnerId = auth.partnerId()
        console.log('[Reverb] listener:', listener, 'partnerId:', partnerId)
        if (!listener || !partnerId) return

        const channel = listener.channel(`partners.${partnerId}`)
        console.log('[Reverb] subscribed to channel:', `partners.${partnerId}`)
        channel.listen('.ReservationCreated', (e) => {
            console.log('[Reverb] ReservationCreated received:', e)
            setReservations(prev => ({ ...prev, update: new Date().getTime() }))
        })

        return () => channel.stopListening('.ReservationCreated')
    }, [listener])

    useEffect(() => {

        let page = searchParams.get('page') || 1

        let filter = {
            res_type_id: searchParams.get('res_type_id') || '',
            employee_id: searchParams.get('employee_id') || '',
            added_by: searchParams.get('added_by') || '',
            status: searchParams.get('status') || '',
            initial_status: searchParams.get('initial_status') || '',
            final_status: searchParams.get('final_status') || '',
            date: searchParams.get('date') || '',
            deadline: searchParams.get('deadline') || '',
            search: searchParams.get('search') || '',
            show_all: searchParams.get('show_all') || 0,
        }

        let shouldUpdate = (JSON.stringify(reservations.filter) !== JSON.stringify(filter) || page !== reservations.page)

        setReservations(prev => ({
            ...prev,
            page: searchParams.get('page') || 1,
            filter: filter,
            update: shouldUpdate ? new Date().getTime() : prev.update
        }))

    }, [location.search])

    useEffect(() => {

        if (reservations.setFilter) {
            let url = '?page=' + reservations.page

            Object.entries(reservations.filter).map(filter => {
                if (filter[1]) {
                    url += '&' + filter[0] + '=' + filter[1]
                }
            })

            history.push(url)
        }

    }, [reservations.setFilter])

    useEffect(() => {
        if (reservations.update) {
            loadData()
        }
    }, [reservations.update])

    useEffect(() => {
        // Listen for reservation accepted events
        const handleReservationAccepted = (event) => {
            console.log('Reservation accepted, refreshing reservations list:', event.detail)
            handleRefresh()
        }

        window.addEventListener('reservationAccepted', handleReservationAccepted)

        return () => {
            window.removeEventListener('reservationAccepted', handleReservationAccepted)
        }
    }, [])

    const loadData = () => {

        let url = 'reservations/all?page=' + reservations.page

        Object.entries(reservations.filter).map(filter => {
            url += '&' + filter[0] + '=' + filter[1]
        })

        setReservations(reservations => ({
            ...reservations,
            data: [],
            loading: true,
        }))

        Api.post(url)
            .then(res => {
                // Ensure shared reservation data is included for each reservation
                const reservationsWithSharedData = res.data?.items?.map(reservation => ({
                    ...reservation,
                    master: {
                        ...reservation.master,
                        is_shared: reservation.master?.is_shared ?? false,
                        shared_by_tenant_id: reservation.master?.shared_by_tenant_id ?? null,
                        allowed_actions: reservation.master?.allowed_actions ?? ['all']
                    }
                })) || []

                setReservations(reservations => ({
                    ...reservations,
                    data: reservationsWithSharedData,
                    total: res.data?.total || 0,
                    today_count: res.data?.today_count || 0,
                    pages: res.data?.pages || 0,
                    loading: false,
                }))
            })
            .catch(err => {
                console.error('Error loading reservations:', err)
                setReservations(reservations => ({
                    ...reservations,
                    data: [],
                    loading: false,
                }))
            })
    }

    const handleSearch = (key, val) => {

        clearTimeout(timeout)

        setReservations(prev => ({
            ...prev,
            filter: {
                ...prev.filter,
                [key]: val,
            },
        }))

        timeout = setTimeout(() => {
            setReservations(prev => ({
                ...prev,
                page: 1,
                setFilter: new Date().getTime()
            }))
        }, 300)

    }

    const handlePage = page => {
        setReservations(prev => ({ ...prev, page: page.selected + 1, setFilter: new Date().getTime() }))
    }

    const handleRefresh = () => {
        setReservations(prev => ({
            ...prev,
            update: new Date().getTime()
        }))
    }

    const handleAddAddressReservation = () => {

        if (isMobile()) {
            return showSelectReservationTypeModal()
        }

        history.push('/schedule/reservations/address/add')
    }

    const handleAddServiceReservation = () => {

        if (isMobile()) {
            return showSelectReservationTypeModal()
        }

        history.push('/schedule/reservations/service/add')
    }

    const showSelectReservationTypeModal = () => {

        let modal = selectReservationTypeModalRef.current

        if (modal) {
            modal.show()
        }
    }

    const isMobile = () => {
        return window.innerWidth <= 1200
    }

    function handleButtonSubmenuClick(e) {
        e.stopPropagation()
        e.preventDefault()

        setOpenButtonDropdown(addAddressReservationButtonRef.current)
    }

    return (
        <>
            <SelectReservationType
                ref={selectReservationTypeModalRef}
            />

            <div className="wrapper">
                <div className="top-part">
                    <div className="left">
                        <h1 className="page-heading">
                            {trans('headings.reservations')} ({reservations.total}) <Help>{fromInfo('reservations')}</Help>
                        </h1>
                        <p className="page-subheading">
                            {trans('subheadings.reservations')}
                        </p>
                    </div>
                    <div className="right" style={{ display: 'flex' }}>
                        <Menu
                            anchorEl={openButtonDropdown}
                            keepMounted
                            open={Boolean(openButtonDropdown)}
                            onClose={() => setOpenButtonDropdown(null)}
                        >
                            <MenuItem onClick={handleAddAddressReservation}>
                                {trans('buttons.addAddressReservation')}
                            </MenuItem>
                            <MenuItem onClick={handleAddServiceReservation}>
                                {trans('buttons.addServiceReservation')}
                            </MenuItem>
                        </Menu>
                        <button onClick={handleAddAddressReservation} className="button button-add with-dropdown" ref={addAddressReservationButtonRef}>
                            {trans('buttons.addAddressReservation')}
                            <i className="menu" onClick={handleButtonSubmenuClick}>

                            </i>
                        </button>
                    </div>
                </div>
                {/* //NEW: Новото място на панела с нови резервации */}
                <Reservation style={{ marginBottom: "15px", marginTop: "45px" }} />
                <Tabs
                    value={moment().isSame(moment(reservations.filter.date), 'day') ? 'today' : 'all'}
                    onChange={(e, newValue) => {
                        if (newValue === 'today') {
                            handleSearch('date', moment().format('YYYY-MM-DD'))
                            handleSearch('deadline', '')
                        } else {
                            handleSearch('date', '')
                            handleSearch('deadline', '')
                        }
                    }}
                    variant="scrollable"
                    scrollButtons="auto"
                    indicatorColor="primary"
                    textColor="primary"
                    aria-label="scrollable force tabs example"
                    allowScrollButtonsMobile

                >
                    <Tab value="today" label={`Резервации от днес (${reservations.today_count || 0})`} />
                    <Tab value="all" label={`Всички резервации (${reservations.total || 0})`} />
                </Tabs>
                <div className='pannel'>
                    <Table
                        loading={reservations.loading}
                        data={reservations.data}
                        filter={reservations.filter}
                        handlePage={handlePage}
                        handleSearch={handleSearch}
                        handleRefresh={handleRefresh}
                        totalToday={reservations.today_count || 0}
                        total={reservations.total || 0}
                    />

                    {!reservations.loading
                        ?
                        <Pagination
                            page={reservations.page}
                            pages={reservations.pages}
                            handlePage={handlePage}
                        />
                        :
                        ''
                    }
                </div>
            </div>
        </>
    )
}

export default Index